<template>
  <div class="report-help-container">
    <!-- 上部分：文字描述 -->
    <div class="content-section">
      <h1 class="title">报表说明</h1>
      <div class="description">
        本指引通过可视化图解，详细解析报表各数据项的定义、计算逻辑及业务应用场景。选择左侧菜单，获取针对性说明。
      </div>
    </div>

    <!-- 下部分：标签页和图片展示 -->
    <div class="tabs-section">
      <a-row style="max-width: 1400px">
        <a-col :span="4">
          <a-menu
              mode="vertical"
              :selectedKeys="[selectedTab.toString()]"
              @select="handleSelect"
              class="tab-menu"
          >
            <a-menu-item v-for="(item,index) in tabs" :key="index">
              {{item.name}}
            </a-menu-item>
          </a-menu>
        </a-col>
        <a-col :span="20">
          <div class="image-container">
            <img :src="`//rp-img.1japp.com/nb-web/help/${selectedTab}.png`" alt="报表说明" />
          </div>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportHelp',
  data() {
    return {
      selectedTab: '0',
      tabs: [
        {
          name: '基本信息',
          img: '0.png'
        },
        {
          name: '活跃度',
          img: '1.png'
        },
        {
          name: '支付方式',
          img: '2.png'
        },
        {
          name: '精准命中',
          img: '3.png'
        },
        {
          name: '收支风险',
          img: '4.png'
        },
        {
          name: '交易对方',
          img: '5.png'
        },
        {
          name: '账单查询',
          img: '6.png'
        },
        {
          name: '异常交易',
          img: '7.png'
        },
        {
          name: '资金流向',
          img: '8.png'
        }
      ]
    }
  },
  methods: {
    handleSelect({ key }) {
      this.selectedTab = key
    }
  }
}
</script>

<style lang="scss" scoped>
.report-help-container {
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;

  .content-section {
    padding: 40px 60px;
    border-bottom: 1px solid #f0f0f0;

    .title {
      font-size: 24px;
      font-weight: bold;
      color: #333;
      margin-bottom: 16px;
    }

    .description {
      font-size: 14px;
      color: #666;
      line-height: 1.6;
      max-width: 800px;
    }
  }

  .tabs-section {
    flex: 1;
    padding: 24px;

    .tab-menu {
      border-right: 1px solid #f0f0f0;
      height: 100%;
    }

    .image-container {
      padding: 0 24px;
      text-align: center;

      img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
        user-select: none;
        -webkit-user-drag: none;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>